import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Api } from '../api/api';
import { HttpClient } from '@angular/common/http';
import { SocketOneProvider } from '../socket-one/socket-one';
import {ConfigurationService} from '../configuration.service';
import {share} from 'rxjs/operators';
/**
 * Most apps have the concept of a User. This is a simple provider
 * with stubs for login/signup/etc.
 *
 * This User provider makes calls to our API at the `login` and `signup` endpoints.
 *
 * By default, it expects `login` and `signup` to return a JSON object of the shape:
 *
 * ```json
 * {
 *   status: 'success',
 *   user: {
 *     // User fields your app needs, like "id", "name", "email", etc.
 *   }
 * }Ø
 * ```
 *
 * If the `status` field is not `success`, then an error is detected and returned.
 */
@Injectable()
export class User {
  _user: any;
  _rootPage: any;

  private backendUrl = '';

    constructor(public api: Api, private http: HttpClient, public socketOne: SocketOneProvider, public config: ConfigurationService) {
        this.backendUrl = this.config.getValue('socketUrl').toString();
        // this.secbackendUrl = this.config.getValue('secSocketUrl').toString();
  }

  getAll(): Observable<any>{
    return this.api.get('users');
  }

  getAllAlertGroups(): Observable<any> {
    return this.api.get('alertGroups');
  }

  /**
   * Send a POST request to our login endpoint with the data
   * the user entered on the form.
   */
  login(accountInfo: any) {
    const seq = this.api.post('login', accountInfo).pipe(share());

    seq.subscribe({next:(res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.status === 200 && res.header.token) {
        this._loggedIn(res);
      } else {
        console.error('ERROR', 'Login fehler');
      }
    }, error: err => {
      console.error('ERROR', err);
    }});

    return seq;
  }

    /* API -> POST-request /auth/register, Anlegen von Benutzerdaten */
    add(user: any){

        return new Promise( (resolve, reject) => {

            const seq = this.http.post(this.backendUrl + '/auth/register', user).pipe(share());
            seq.subscribe({next:(res: any) => {

                // when alles OK, senden eine Anfrage forgot-password an Benutzer, um das pwd neu zu setzen
                this.http.post(this.backendUrl + '/auth/forgot-password', {email: user.email}).subscribe(() => {}, (err) => {
                  console.log(err);
                });
                // was machen mit seq_email?
                resolve(res);
            }, error: err => {
                reject(err);
            }});

        });

    }

    /* API -> POST-request /auth/forgot-password, Link zum Setzen des Passworts verschicken */
    forgotPassword(email: string){

        return new Promise((resolve, reject) => {
          const fp = this.http.post(this.backendUrl + '/auth/forgot-password', {email}).pipe(share());
          fp.subscribe({next:(res: any) => {
            resolve(res);
          }, error: err => {
            reject(err);
          }});
        });
    }

    /* API -> DELETE-request /service/user, Löschen von Benutzerdaten bei eingegebenem ID */
    delete(user: any){

        return new Promise((resolve, reject) => {
            this.api.delete('user', {_id: user._id, _rev: user._rev}).subscribe({next:(res: any) => {
                resolve(res);
            }, error: err => {
                reject(err);
            }});
        });
    }

    /* API -> GET-request /service/user, Laden von Benutzerdaten bei eingegebenem ID */
    get(_id: string){

        return new Promise((resolve, reject) => {
            this.api.get('user', {_id}).subscribe({next:(res: any) => {
                resolve(res);
            }, error:err => {
                reject(err);
            }});
        });
    }

    /* API -> POST-request /service/user, zum Editieren von Benutzerdaten *///
    update(user: any){
        return new Promise( (resolve, reject) => {
            this.api.post('user', {body: user}).subscribe({next:(res: any) => {
                resolve(res);
                this.api.postSocket2('user', {body: user});
            }, error: err => {
                reject(err);
            }});
        });
    }

    /* API -> GET-request /service/userByEmail *///
    getByEmail(email: string){

        return new Promise( (resolve, reject) => {
            this.api.get('userByEmail', {email}).subscribe({next:(res: any) => {
                resolve(res);
            }, error: err => {
                reject(err);
            }});
        });
    }

  /**
   * Send a POST request to our signup endpoint with the data
   * the user entered on the form.
   */
  signup(accountInfo: any) {
    const seq = this.api.post('signup', accountInfo).pipe(share());

    seq.subscribe({next:(res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.status === 'success') {
        this._loggedIn(res);
      }
    }, error:err => {
      console.error('ERROR', err);
    }});

    return seq;
  }

  /**
   * Log the user out, which forgets the session
   */
  logout() {
    this._user = null;
  }

  /**
   * Process a login/signup response to store user data
   */
  _loggedIn(resp) {
    this._user = resp.user;
  }

  setInventarDbName(dbName: any): void {
    localStorage.setItem('inventarDbName', dbName);
  }

  getInventarDbName(): string {
    const name = localStorage.getItem('inventarDbName');
    if (name) {
      return name;
    } else {
      return '';
    }
  }

  setInventarLoginData(token: string, pass: string) {
    localStorage.setItem('authInventar', token + ':' + pass);
  }

  getInventarLoginData() {
    const data = localStorage.getItem('authInventar');
    if (data) {
      const sp = data.split(':');
      return {username: sp[0], password: sp[1]};
    } else {
      return false;
    }
  }

  logoutInvntar(): void {
    localStorage.removeItem('inventarDbName');
    localStorage.removeItem('authInventar');
  }
}
